import React from "react";
import Select from "react-select";

function InputBoxSelect({ options, label, placeholder, type, ...otherprops }) {
  return (
    <div className="flex flex-col w-80">
      <label className="text-sm font-semibold text-gray-600" {...otherprops}>
        {label}
      </label>
      <Select
        className="disabled:text-gray-800 disabled:bg-gray-200 w-80 px-4 py-2 mt-2 border rounded-md border-gray-400 focus:outline-none focus:border-blue-500"
        type={type}
        placeholder={placeholder}
        isDisabled={otherprops.disabled}
        {...otherprops}
        options={options}
      />
    </div>
  );
}

export default InputBoxSelect;
